
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { format } from "date-fns";
import CustomToast from '../../components/CustomToast';
const Brand_calender = () => {
    const { accessToken, userId, role } = useAuth();
    const toastRef = useRef(null);
    const [events, setEvents] = useState([]);
    const [brands, setBrands] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showRescheduleDialog, setShowRescheduleDialog] = useState(false);
    const [rescheduleData, setRescheduleData] = useState({
        old_post_id: "",
        start: "",
        new_event_date: "",
        reason: "",
    });

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };


    const [dialogData, setDialogData] = useState({
        id: "",
        title: "",
        start: "",
        color: "#FF0000",
        status: "Pending",
        brand: "",
        brandName: "", // Store the brand name
        event_url: "", // Added event_url here
        postedBy: {
            name: "",
            image: "",
        },
        updatedBy: {
            name: "",
            image: "",
        },
    });

    const [isEditing, setIsEditing] = useState(false);

    const statusOptions = [
        { label: "Pending", value: "Pending", color: "#ff9800" },
        { label: "Posted", value: "Posted", color: "#4caf50" },
        { label: "Cancelled", value: "Cancelled", color: "#ff0000" },
        { label: "Date Changed", value: "Date_Changed", color: "#2196F3" },
        { label: "Deadline Missed", value: "Deadline_missed", color: "#9C27B0" },
    ];

    const colors = [
        { color: "#FF0000", name: "Red" },
        { color: "#0000FF", name: "Blue" },
        { color: "#FFD700", name: "Gold" },
        { color: "#50C878", name: "Emerald" },
        { color: "#7851A9", name: "Purple" },
        { color: "#40E0D0", name: "Turquoise" },
        { color: "#FF7F50", name: "Coral" },
        { color: "#FF00FF", name: "Magenta" },
        { color: "#000080", name: "Navy" },
        { color: "#DC143C", name: "Crimson" },
        { color: "#228B22", name: "Forest Green" },
        { color: "#008080", name: "Teal" },
        { color: "#87CEEB", name: "Sky Blue" },
        { color: "#FF66CC", name: "Pink" },
        { color: "#7FFF00", name: "Chartreuse" },
        { color: "#FFBF00", name: "Amber" },
        { color: "#708090", name: "Slate Gray" },
        { color: "#32CD32", name: "Lime Green" },
        { color: "#191970", name: "Midnight Blue" },
        { color: "#FF69B4", name: "Hot Pink" },
        { color: "#800000", name: "Maroon" },
        { color: "#2E8B57", name: "Sea Green" },
        { color: "#DDA0DD", name: "Plum" },
        { color: "#808000", name: "Olive" },
        { color: "#B87333", name: "Copper" },
    ];


    const fetchEvents = async (startDate, endDate) => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/brandingRoutes/brand-calendar`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { start_date: startDate, end_date: endDate },
            });

            const eventList = response.data.map(event => ({
                id: event.brand_calander_id.toString(),
                title: event.event_name,
                start: event.event_date,
                color: event.event_color || "#3788d8",
                status: event.event_status,
                brand: event.brand_id,
                brandName: event.brand?.brand_name || "",
                event_url: event.event_url,
                postedBy: event.postedBy
                    ? {
                        name: `${event.postedBy.first_name || ""} ${event.postedBy.last_name || ""}`.trim(),
                        image: event.postedBy.profileImage?.image_url || "",
                    }
                    : { name: "Unknown", image: "" },


                updatedBy: event.updatedBy
                    ? {
                        name: `${event.updatedBy.first_name || ""} ${event.updatedBy.last_name || ""}`.trim(),
                        image: event.updatedBy.profileImage?.image_url || "",
                    }
                    : { name: "Unknown", image: "" },
            }));

            setEvents(eventList);
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };



    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            const brandOptions = response.data.map(brand => ({
                label: brand.brand_name,
                value: brand.brand_id,
            }));
            setBrands(brandOptions);
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const saveEvent = async () => {
        setLoading(true);
        try {
            const { id, title, start, color, status, brand, event_url } = dialogData;
            const payload = {
                brand_calander_id: id,
                brand_id: brand,
                event_name: title,
                event_date: start,
                event_status: status,
                event_color: color,
                event_url: event_url || "", // Ensure event_url is always sent
                user_id: userId,  // Include userId
            };


            await axios.post(`${config.apiBASEURL}/brandingRoutes/brand-calendar`, payload, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            // Refresh events after save
            // Refresh events after save
            const today = new Date(dialogData.start);

            const startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0); // Midnight start
            const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59); // End of last day

            fetchEvents(startDate.toISOString(), endDate.toISOString());
            setDialogVisible(false);
            setLoading(false);
        } catch (error) {
            console.error('Error saving event:', error);
            setLoading(false);
        }
    };

    const openDialog = (data, isEdit) => {
        setDialogData(data);
        setIsEditing(isEdit);
        setDialogVisible(true);
    };
    const handleDateSelect = (selectInfo) => {
        openDialog({ id: "", title: "", start: selectInfo.startStr, color: "#3788d8", status: "Pending", brand: "" }, false);
        selectInfo.view.calendar.unselect();
    };

    const handleEventClick = (clickInfo) => {
        const clickedEvent = events.find(event => event.id === clickInfo.event.id);

        if (clickedEvent) {
            if (clickedEvent.status === "Deadline_missed") {
                // If status is 'Deadline_missed', check the role
                if (role === 'Employee' || role === 'Social_Media_Manager') {
                    // Show event data dialog for 'Employee' and 'Social_Media_Manager'
                    setDialogData({
                        id: clickedEvent.id,
                        title: clickedEvent.title,
                        start: clickedEvent.start,
                        color: clickedEvent.color,
                        status: clickedEvent.status,
                        brand: clickedEvent.brand,
                        event_url: clickedEvent.event_url,
                        brandName: clickedEvent.brandName || "",
                        postedBy: clickedEvent.postedBy || { name: "N/A", image: "" },
                        updatedBy: clickedEvent.updatedBy || { name: "N/A", image: "" },
                    });

                    setIsEditing(false); // No editing for 'Deadline_missed' status
                    setDialogVisible(true);
                } else {
                    // For other roles, show the reschedule dialog
                    setRescheduleData({
                        id: clickedEvent.id,
                        old_post_id: clickedEvent.id,
                        start: clickedEvent.start,
                        new_event_date: "",
                        reason: "",
                    });
                    setShowRescheduleDialog(true);
                }
            } else {
                // If the status is not 'Deadline_missed', show event data dialog for all roles
                setDialogData({
                    id: clickedEvent.id,
                    title: clickedEvent.title,
                    start: clickedEvent.start,
                    color: clickedEvent.color,
                    status: clickedEvent.status,
                    brand: clickedEvent.brand,
                    event_url: clickedEvent.event_url,
                    brandName: clickedEvent.brandName || "",
                    postedBy: clickedEvent.postedBy || { name: "N/A", image: "" },
                    updatedBy: clickedEvent.updatedBy || { name: "N/A", image: "" },
                });

                setIsEditing(true); // Allow editing for non-'Deadline_missed' events
                setDialogVisible(true);
            }
        } else {
            console.error("Event not found:", clickInfo.event.id);
        }
    };

    const handleRescheduleSubmit = async () => {
        if (!rescheduleData.new_event_date || !rescheduleData.reason) {
            showMessage("error", "Please fill in all fields.");
            return;
        }

        try {
            // Convert date to local YYYY-MM-DD format before sending
            const newEventDate = rescheduleData.new_event_date;
            const formattedDate = newEventDate
                ? newEventDate.getFullYear() +
                "-" +
                String(newEventDate.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(newEventDate.getDate()).padStart(2, "0")
                : "";
            const response = await axios.post(
                `${config.apiBASEURL}/brandingRoutes/brand-calendar/duplicate-with-new-date`,
                {
                    old_post_id: rescheduleData.old_post_id,
                    new_event_date: formattedDate, // Send formatted local date
                    user_id: userId, // Get user ID from auth state
                    reason: rescheduleData.reason,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`, // Add authentication if needed
                    },
                }
            );

            setShowRescheduleDialog(false);


            // Refresh events after save
            const today = new Date(dialogData.start);

            const startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0); // Midnight start
            const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59); // End of last day

            fetchEvents(startDate.toISOString(), endDate.toISOString());

        } catch (error) {
            console.error("Error rescheduling event:", error);

        }
    };




    useEffect(() => {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0); // Midnight start
        const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59); // End of last day

        fetchEvents(startDate.toISOString(), endDate.toISOString());
        fetchBrands();
    }, []);





    return (
        <>
            <Row className="body_content w-100">
                <Row className="justify-content-between align-items-center">
                    <Col md={12} className="mb-4">
                        <FullCalendar
                            plugins={[dayGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            selectable
                            editable
                            events={events}
                            dayMaxEventRows={4}
                            contentHeight="auto"
                            select={handleDateSelect}
                            eventClick={handleEventClick}
                            eventContent={(eventInfo) => {
                                const statusColor = {
                                    Pending: "#ff9800",
                                    Posted: "#48eb4e",
                                    Cancelled: "#ff0000",
                                }[eventInfo.event.extendedProps.status] || "#3788d8";

                                return (
                                    <p className='d-flex align-items-center mb-0 cal_elp'>
                                        <small
                                            style={{
                                                width: "7px",
                                                height: "7px",
                                                backgroundColor: statusColor,
                                                borderRadius: "50%",
                                                marginRight: "5px",
                                                position: "absolute",
                                                top: "3px",
                                                right: "-3px",
                                                border: "2px solid transparent",
                                            }}
                                        ></small>
                                        {eventInfo.event.extendedProps.brandName && (
                                            <em>
                                                {eventInfo.event.extendedProps.brandName}
                                            </em>
                                        )}
                                        &nbsp; - &nbsp;
                                        <span>{eventInfo.event.title}</span>
                                    </p>
                                );
                            }}
                            headerToolbar={{
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,dayGridWeek,dayGridDay",
                            }}
                            datesSet={(dateInfo) => {
                                const startDate = new Date(dateInfo.start).toISOString();
                                const endDate = new Date(dateInfo.end).toISOString();
                                fetchEvents(startDate, endDate);
                            }}
                        />


                        <Dialog
                            header={isEditing ? "Edit Post" : "Add Post"}
                            visible={dialogVisible}
                            style={{ width: "400px", height: "62vh", overflow: "auto" }}
                            footer={
                                <div className='border-top pt-3 bg-light'>
                                    <Button label="Cancel" onClick={() => setDialogVisible(false)} className="border-0 py-2" severity="secondary" disabled={loading} />
                                    {/* Hide Save button if status is 'Date_Changed' or 'Deadline_missed' */}
                                    {dialogData.status !== "Date_Changed" && dialogData.status !== "Deadline_missed" && (
                                        <Button
                                            label={loading ? "Saving..." : "Save"}
                                            icon={loading ? "pi pi-spin pi-spinner" : ""}
                                            onClick={saveEvent}
                                            className="border-0 ms-2 py-2"
                                            severity="success"
                                            disabled={loading || (isEditing && (dialogData.status === "Pending" || dialogData.status === "Posted") && !dialogData.event_url)}
                                        />

                                    )}
                                </div>
                            }
                            onHide={() => setDialogVisible(false)}
                        >
                            {isEditing && dialogData.postedBy &&
                                Object.keys(dialogData.postedBy).length > 0 &&
                                dialogData.postedBy.name?.trim() !== "" && (
                                    <div className="p-field mt-3">
                                        <label>Posted By</label>
                                        <div className="d-flex align-items-center">
                                            {dialogData.postedBy.image?.trim() !== "" && (
                                                <img
                                                    src={dialogData.postedBy.image}
                                                    alt={dialogData.postedBy.name}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                                />
                                            )}
                                            <span>{dialogData.postedBy.name}</span>
                                        </div>
                                    </div>
                                )}
                            <div className="p-field">
                                <label htmlFor="brand">Select Brand</label>
                                <Dropdown
                                    id="brand"
                                    value={dialogData.brand}
                                    options={brands}
                                    onChange={(e) => setDialogData({ ...dialogData, brand: e.value })}
                                    placeholder="Select a Brand"
                                />
                            </div>
                            <div className="p-field mt-3">
                                <label htmlFor="title">Post Type</label>
                                <InputText
                                    id="title"
                                    value={dialogData.title}
                                    onChange={(e) => setDialogData({ ...dialogData, title: e.target.value })}
                                />
                            </div>
                            <div className="p-field mt-3">
                                <label htmlFor="start">Post Date</label>
                                <InputText
                                    id="start"
                                    value={dialogData.start ? format(new Date(dialogData.start), "dd-MM-yyyy") : ""}
                                    onChange={(e) => setDialogData({ ...dialogData, start: e.target.value })}
                                    disabled
                                />
                            </div>

                            {/* Event URL (Only When Editing) */}
                            {isEditing && (
                                <div className="p-field mt-3">
                                    <label htmlFor="event_url">Event URL</label>
                                    <InputTextarea
                                        id="event_url"
                                        className='h-auto'
                                        rows={4}
                                        value={dialogData.event_url || ""}
                                        onChange={(e) => setDialogData({ ...dialogData, event_url: e.target.value })}
                                        required={dialogData.status === "Pending" || dialogData.status === "Posted"} // Make it required when status is 'Pending' or 'Posted'
                                    />
                                    {(dialogData.status === "Pending" || dialogData.status === "Posted") && !dialogData.event_url && (
                                        <small className="text-danger">Event URL is required when posting the event.</small>
                                    )}
                                </div>
                            )}




                            {isEditing && (
                                <div className="p-field mt-3">
                                    <label htmlFor="status">Post Status</label>
                                    <Dropdown
                                        id="status"
                                        value={dialogData.status}
                                        options={statusOptions}
                                        onChange={(e) => setDialogData({ ...dialogData, status: e.value })}
                                        placeholder="Select a status"
                                        disabled={dialogData.status === 'Date_Changed' || dialogData.status === 'Deadline_missed'} // Disable if status is Date_Changed or Deadline_missed
                                    />

                                </div>
                            )}
                            <div className="p-field d-flex flex-column justify-content-start align-items-center mt-3">
                                <label htmlFor="color" className="text-start w-100 mb-2">Select Color</label>
                                <div className="d-flex w-100 align-items-center">
                                    {/* Dropdown for selecting color */}
                                    <select
                                        id="color"
                                        className="form-select w-75 me-2"
                                        value={dialogData.color}
                                        onChange={(e) => setDialogData({ ...dialogData, color: e.target.value })}
                                    >
                                        <option value="" disabled>Select a color</option>
                                        {colors.map(({ color, name }) => (
                                            <option key={color} value={color}>
                                                {name}
                                            </option>
                                        ))}
                                    </select>

                                    {/* Color preview box */}
                                    {dialogData.color && (
                                        <div
                                            className="color-preview-circle"
                                            style={{
                                                width: "46px",
                                                height: "46px",
                                                backgroundColor: dialogData.color,
                                                borderRadius: "5px",
                                                border: "none",
                                            }}
                                        ></div>
                                    )}
                                </div>
                            </div>
                            {isEditing && dialogData.updatedBy &&
                                Object.keys(dialogData.updatedBy).length > 0 &&
                                dialogData.updatedBy.name?.trim() !== "" && (
                                    <div className="p-field mt-3">
                                        <label>Last Updated By</label>
                                        <div className="d-flex align-items-center">
                                            {dialogData.updatedBy.image?.trim() !== "" && (
                                                <img
                                                    src={dialogData.updatedBy.image}
                                                    alt={dialogData.updatedBy.name}
                                                    className="rounded-circle me-2"
                                                    style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                                />
                                            )}
                                            <span>{dialogData.updatedBy.name}</span>
                                        </div>
                                    </div>
                                )}
                        </Dialog>
                        <Dialog
                            header="Reschedule Post"
                            visible={showRescheduleDialog}
                            style={{ width: "400px" }}
                            footer={
                                <div>
                                    <Button label="Cancel" onClick={() => setShowRescheduleDialog(false)} className="border-0 py-2" severity="secondary" />
                                    <Button label="Submit" onClick={handleRescheduleSubmit} className="border-0 ms-2 py-2" severity="success" />
                                </div>
                            }
                            onHide={() => setShowRescheduleDialog(false)}
                        >
                            <div className="p-field mt-3">
                                <label htmlFor="start">Previous Event Date</label>
                                <InputText
                                    id="start"
                                    value={rescheduleData.start ? format(new Date(rescheduleData.start), "dd-MM-yyyy") : ""}
                                    onChange={(e) => setDialogData({ ...rescheduleData, start: e.target.value })}
                                    disabled
                                />
                            </div>
                            <div className="p-field">
                                <label htmlFor="newDate">New Event Date</label>
                                <Calendar
                                    id="newDate"
                                    value={rescheduleData.new_event_date}
                                    onChange={(e) => setRescheduleData({ ...rescheduleData, new_event_date: e.value })}

                                />
                            </div>
                            <div className="p-field mt-3">
                                <label htmlFor="reason">Reason</label>
                                <InputTextarea
                                    id="reason"
                                    value={rescheduleData.reason}
                                    onChange={(e) => setRescheduleData({ ...rescheduleData, reason: e.target.value })}
                                    rows={3}
                                    placeholder="Enter reason for rescheduling"
                                />
                            </div>
                        </Dialog>


                    </Col>
                </Row>
            </Row>
            <CustomToast ref={toastRef} />
        </>
    );
};

export default Brand_calender;